<template>
  <div id="app">
    <Panels />
    <portal-target name="popups">
    </portal-target>
  </div>
</template>

<script>
import Panels from './components/Panels.vue'

export default {
    name: 'App',
    components: { Panels }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
